export default "__VITE_ASSET__BzH4bq7___"